/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MasterDataTable.vue?vue&type=template&id=154a07f8&scoped=true&"
import script from "./MasterDataTable.vue?vue&type=script&lang=js&"
export * from "./MasterDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MasterDataTable.vue?vue&type=style&index=0&id=154a07f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a07f8",
  null
  
)

export default component.exports